import { Button } from '@/components/shadcn/ui/button';
import { Command, CommandInput, } from '@/components/shadcn/ui/command';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/components/shadcn/ui/dialog';
import FormTask from './Task/FormTask';
import React, { useEffect, useState } from 'react';
import CardTask from './Task/CardTask';
import { Tabs, TabsList, TabsTrigger } from '@/components/shadcn/ui/tabs';
import { TabsContent } from '@radix-ui/react-tabs';
import CardComment from './Comment/CardComment';
import FormComment from './Comment/FormComment';
import { ClipboardCheckIcon, ClipboardListIcon, FileIcon, MessageSquareIcon, User } from 'lucide-react';
import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import { _BusinessComment } from '@/entities/business';
import { useParams } from 'react-router-dom';
import { ScrollArea } from '@/components/shadcn/ui/scroll-area';
import { BusinessService } from '@/services/BusinessService';
import useComments from '@/hook/useComments';
import { DialogTitle } from '@radix-ui/react-dialog';
import { useUsers } from '@/hook/useUsers';
import { useBusiness } from '@/hook/useBusiness';
import { useAuthContext } from '@/context/AuthContext';
import { useTasks } from '@/hook/useTasks';
import { useTaskContext } from '@/context/TaskContext';
import AtachmentsDialog from './Attachments/AttechmentsDialog';
import { useAttachments } from '@/hook/useAttachments';
import CardAttachments from './Attachments/AttachmentCard';
import { BusinessAttachments } from '@/entities/businessAttachments';

interface TaskFormData {
  id: number,
  description: string,
  businessId: number,
  userName: string,
  activityTypesId: number,
  userId: number,
  prevision: Date,
  iniciatedAt: Date,
  notification: boolean,
  observation: string,
  priority: number,
  situation: number,
  done: string,
  companyId: number,
  conclusionAt: Date | null,
  activityType: string,
  userWhoAdds: string,
}

const Timeline: React.FC = () => {
  const [openT, setOpenT] = useState(false);
  const [openP, setOpenP] = useState(false);
  const [openC, setOpenC] = useState(false);
  const [openI, setOpenI] = useState(false);
  const [comments, setComments] = useState<_BusinessComment[]>([]);
  const [indexP, setIndexP] = useState<number | undefined>(undefined);
  const [indexI, setIndexI] = useState<number | undefined>(undefined);
  const [indexC, setIndexC] = useState<number | undefined>(undefined);
  const [indexT, setIndexT] = useState<number | undefined>(undefined);
  // const [tasks, setTasks] = useState<TaskFormData[]>([]);
  const [taskEdit, setTaskEdit] = useState<TaskFormData>();
  const [editComment, setEditComment] = useState<{
    businessId: number,
    commentId: number,
    comment: string
  }>();

  const [ownerId, setOwnerid] = useState<number>();

  const { business } = useBusinessDetailContext();
  const leadId = Number(useParams().leadId);
  const { isEditComment, setIsEditComment, updateComment } = useComments();
  const { users, userId } = useUsers();
  const { accessToken } = useAuthContext();
  const { attachments, deleteBusinessAttachments, getBusinessAttachments } = useAttachments(leadId);
  const [fakeAttachments, setFakeAttachments] = useState<BusinessAttachments[]>([]);
  const { business2 } = useBusiness(leadId, accessToken?.userId);
  const { tasksR, getTasks, createTasks, updateTask, deleteTask, updateTaskDone } = useTasks(leadId);
  const { dataTaskEdit, setDataTaskEdit, tasks, setTasks, setCardTitle, setIcon, setBgColor, setIsCompleted } = useTaskContext();

  const loggedUser = users.find((u) => u.userId === accessToken?.userId)?.name;
  useEffect(() => {
    if (!business) return;

    setComments(business.businessComments.map(
      (businessComment: _BusinessComment) => ({ ...businessComment })
    ));
    // console.log(filteredListP);

    const ownerId = users.find((user) => user.userId === business2?.createdById)?.userId;
    setOwnerid(ownerId);
    setFakeAttachments(attachments);
    const tasks2Date = tasksR.map((t) => ({
      id: t.id,
      description: t.description,
      businessId: t.businessId,
      userName: t.user.name,
      activityTypesId: Number(t.activityTypesId),
      userId: Number(t.userId),
      prevision: t.prevision,
      iniciatedAt: t.iniciatedAt,
      notification: t.notification === 1 ? true : false,
      observation: t.observation,
      priority: t.priority,
      situation: t.situation,
      done: t.done,
      companyId: t.companyId,
      conclusionAt: t.conclusionAt,
      activityType: t.activityTypes.name,
      userWhoAdds: t.userWhoAdds,
    }));
    setTasks(tasks2Date);

  }, [business]);

  // todo: adicionar comentário
  const handleCommentSubmit = async (comment: string) => {
    const businesComment = {
      businessId: leadId,
      comment
    };

    const newComment = await BusinessService.createBusinessComment(businesComment);

    if (newComment) {
      setComments([newComment, ...comments]);
    }

    setOpenC(!openC);
  };

  const handleTaskSubmit = async (formData: TaskFormData) => {

    const data2Create = {
      description: formData.description,
      userId: Number(formData.userId),
      businessId: leadId,
      activityTypesId: Number(formData.activityTypesId),
      iniciatedAt: formData.iniciatedAt,
      prevision: formData.prevision,
      done: formData.done,
      conclusionAt: formData.conclusionAt,
      notification: formData.notification === true ? 1 : 0,
      observation: formData.observation,
      priority: formData.priority,
      situation: formData.situation,
      userWhoAdds: formData.userWhoAdds,
    };

    const response = createTasks(data2Create);
    let test: any;
    await response.then((result) => {
      test = result;
    }).catch((error) => {
      console.error(error);
    }).finally(() => {
      // console.log(test);
    });
    const dataT = {
      description: formData.description,
      businessId: leadId,
      userName: formData.userName,
      activityTypesId: formData.activityTypesId,
      userId: formData.userId,
      prevision: formData.prevision,
      iniciatedAt: formData.iniciatedAt,
      notification: formData.notification,
      observation: formData.observation,
      priority: formData.priority,
      situation: formData.situation,
      done: formData.done,
      companyId: formData.companyId,
      conclusionAt: formData.conclusionAt,
      activityType: formData.activityType,
      userWhoAdds: formData.userWhoAdds,
    };

    if (!response) return;
    setTasks([...tasks, dataT]);

  };

  const handleCommentDelete = async (index: number) => {
    const newComments = [...comments];
    await BusinessService.deleteBusinessComment(newComments[index].id);
    newComments.splice(index, 1);
    setComments(newComments);
  };

  const handleDeleteAttachments = async (index: number) => {
    const newAttachments = fakeAttachments.map((a: any) => ({
      businessId: a.businessId,
      createdAt: a.createdAt,
      description: a.description,
      id: a.id,
      path: a.path,
      updatedAt: a.updatedAt,
    }));
    const id = newAttachments[index].id;
    deleteBusinessAttachments(id);
    newAttachments.splice(index, 1);
    setFakeAttachments(newAttachments);
  };

  const handleTaskDelete = (index: number) => {
    const newTasks = [...tasks];
    deleteTask(newTasks[index].id);
    newTasks.splice(index, 1);
    setTasks(newTasks);
  };

  {/** será usado futuramente para Update do formulário! */ }
  const handleReopenModal = (index: number) => {
    const reopenedComment = comments[index];

    setEditComment({
      businessId: leadId,
      commentId: reopenedComment.id,
      comment: reopenedComment.comment
    });
    setIndexC(index);
    setOpenC((openC) => !openC);
  };

  const handleVis = (filePath: string) => {
    const fileExtension = filePath.split('.').pop()?.toLowerCase();

    // Verifica o tipo de arquivo e abre adequadamente
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension || '')) {
      // Cria a URL completa para a imagem (usando a URL pública do servidor)
      const imageUrl = `10.86.254.128:3001/uploads/${filePath}`;

      // Abre a imagem em uma nova aba
      window.open(imageUrl, '_blank');
    } else if (['pdf'].includes(fileExtension || '')) {
      // Abre PDFs diretamente em uma nova aba
      const pdfUrl = `10.86.254.128:3001/uploads/${filePath}`;
      window.open(pdfUrl, '_blank');
    } else {
      // Outros arquivos podem ser tratados de maneira diferente (ex. abrir em modal ou mostrar erro)
      alert('Visualização do arquivo não suportada');
    }
  };

  const handleEditComment = (index: number, comment: any) => {
    // const Comments = [...comments];
    const coment = {
      id: comments[index].id,
      comment: comment.comment
    };
    updateComment(coment.id, coment);
    comments[index].comment = coment.comment;
    setOpenC((openC) => !openC);
  };

  const editOrCreateComment = (index: number | undefined, data: any | undefined) => {
    if (index === undefined) {
      handleCommentSubmit(data.comment);
    }
    else if (index !== undefined) {
      handleEditComment(index, data);
    }
  };



  const handleUpdateTask = (data: any, index: number) => {

    const data2Update = {
      id: data.id,
      description: data.description,
      userId: data.userId,
      activityTypesId: data.activityTypesId,
      iniciatedAt: data.iniciatedAt,
      prevision: data.prevision,
      conclusionAt: data.conclusionAt,
      notification: data.notification === true ? 1 : 0,
      observation: data.observation,
      priority: data.priority,
      situation: data.situation,
      done: data.done,
    };

    tasks[index].description = data.description;
    tasks[index].userId = data.userId;
    tasks[index].activityTypesId = data.activityTypesId;
    tasks[index].iniciatedAt = data.iniciatedAt;
    tasks[index].prevision = data.prevision;
    tasks[index].conclusionAt = data.conclusionAt;
    tasks[index].notification = data.notification;
    tasks[index].observation = data.observation;
    tasks[index].priority = data.priority;
    tasks[index].situation = data.situation;
    tasks[index].done = data.done;

    updateTask(data2Update);

  };

  const handleReopenModalTask = (index: number) => {
    const reopenedTask = tasks[index];
    setIndexT(index);
    setDataTaskEdit(reopenedTask);
    if (reopenedTask.userWhoAdds !== loggedUser) {
      alert('Apenas o usuário criador da tarefa pode editar!');
    } else {
      setOpenT((openT) => !openT);
    }
  };


  const EditOrCreateTask = (data: TaskFormData, index: number | undefined) => {
    if (index !== undefined) {
      handleUpdateTask(data, index);
    } else {
      handleTaskSubmit(data);
    }
    setOpenT(!openT);
  };


  const handleTaskComplete = (index: number) => {

    const formData = tasks[index];
    const data2Update = {
      id: formData.id,
      description: formData.description,
      userId: formData.userId,
      activityTypesId: formData.activityTypesId,
      iniciatedAt: formData.iniciatedAt,
      prevision: formData.prevision,
      conclusionAt: formData.conclusionAt,
      notification: formData.notification === true ? 1 : 0,
      observation: formData.observation,
      priority: formData.priority,
      situation: formData.situation,
      done: formData.done === 'S' ? 'N' : 'S',
    };

    tasks[index].done = tasks[index].done === 'S' ? 'N' : 'S';
    updateTaskDone(data2Update);
    setCardTitle('Tarefa Concluída');
    setIcon(<ClipboardCheckIcon size={14} color='white' />);
    setBgColor('bg-green-500');
    setIsCompleted(true);
  };

  return (
    <div className='bg-white'>
      <div className='flex bg-white mx-4 p-2 rounded-lg border gap-2 justify-end'>
        <div className='w-[1000px] flex'>
        <Command className='w-2/3 border'>
          <CommandInput placeholder='Digite para pesquisar...' />
          {/*<CommandList>
              <CommandGroup>
                <CommandEmpty>Resultados não encontrados.</CommandEmpty> 
              </CommandGroup>
            </CommandList>*/}
        </Command>

        <Dialog open={openT} onOpenChange={setOpenT}>
          <DialogTrigger >
            <Button

              title='Adicionar Tarefa'
              className='flex gap-1 h-10 text-slate-500 border text-sm bg-white hover:bg-indigo-100'
              onClick={() => {
                setIndexT(undefined);
                setDataTaskEdit(undefined);
              }}
            >
              <ClipboardListIcon size={20} className='text-slate-500' /> Tarefa
            </Button>
          </DialogTrigger>
          <DialogContent className='h-[80%]'>
            <FormTask
              open={openT}
              onTaskSubmit={EditOrCreateTask}
              index={indexT}
            />
          </DialogContent>
        </Dialog>

        <Dialog open={openC} onOpenChange={setOpenC}>
          <DialogTrigger>
            <Button onClick={() => setEditComment(undefined)} title='Adicionar Comentário' className='flex gap-1 text-white text-sm text-slate-500 border  bg-white hover:bg-indigo-100'>
              <MessageSquareIcon size={20} className='text-slate-500 ' /> Comentário
            </Button>
          </DialogTrigger>
          <DialogContent className='w-4/5 h-[40%]'>
            <DialogHeader>
              <DialogTitle>
                <div className='flex items-center gap-2'>
                  <MessageSquareIcon size={22} />
                  <b className='font-semibold' >Comentário</b>
                </div>
              </DialogTitle>
            </DialogHeader>
            <FormComment
              onCommentSubmit={editOrCreateComment}
              comment={editComment}
              index={indexC}
            />
          </DialogContent>
        </Dialog>
        <AtachmentsDialog />
      </div>
      </div>
      <div className='flex flex-col mt-2 rounded-lg mx-4 bg-white border border-slate-200'>
        <Tabs defaultValue='timeline'>
          <TabsList className='flex justify-start items-center border-b border-slate-200 w-full'>
            {/* <TabsTrigger value='resumo'>Resumo</TabsTrigger> */}
            <TabsTrigger value='timeline'> Timeline
              {/* <div className='my-1 mx-1 h-5 w-5 bg-indigo-400 rounded rounded-full text-white text-xs content-center'>
                2
              </div> */}
            </TabsTrigger>

            <TabsTrigger value='anexos'> Anexos
            </TabsTrigger>

            <TabsTrigger value='tarefas'> Tarefas
            </TabsTrigger>

          </TabsList>
          <ScrollArea className="h-[450px] p-4  mb-2" >
            <TabsContent value='timeline' className='mt-6'>
              {comments.length > 0 ? (
                comments.map((comment, index) => (
                  <CardComment
                    key={index}
                    user={comment.user}
                    comment={comment}
                    onDelete={() => handleCommentDelete(index)}
                    onReopenModal={() => handleReopenModal(index)}
                  />
                ))
              ) : (
                <p className="text-center text-gray-500">Este campo está vazio, adicione mais informações</p>
              )}

            </TabsContent>

            <TabsContent value='anexos' className='mt-6'>
              {fakeAttachments.length > 0 ? (
                fakeAttachments.map((att, index) => (
                  <CardAttachments
                    key={index}
                    file={att}
                    onDelete={() => handleDeleteAttachments(index)}
                    onVis={handleVis}
                  />
                ))
              ) : (
                <p className="text-center text-gray-500">Este campo está vazio, adicione mais informações</p>
              )}
            </TabsContent>

            <TabsContent value='tarefas' className='mt-6'>
              {tasks.length > 0 ? (
                tasks.map((formData: any, index: number) => (
                  <CardTask
                    key={index}
                    handleTaskComplete={() => handleTaskComplete(index)}
                    formData={formData}
                    onDelete={() => handleTaskDelete(index)}
                    onReopenModal={() => handleReopenModalTask(index)}
                  />
                ))
              ) : (
                <p className="text-center text-gray-500">Este campo está vazio, adicione mais informações</p>
              )}
            </TabsContent>

          </ScrollArea>
        </Tabs>
      </div>
    </div>
  );
};

export default Timeline;
